<template>
  <div class="page" v-if="!isNullBaseData">
    <div class="resister-tips" v-if="isRegister">
      <van-notice-bar class="notice-bar" color="#333" wrapable :scrollable="false" background="rgb(240, 249, 235)" v-if="code == 1">
        <template #left-icon>
          <van-icon name="checked" color="#07c160" size="1.5em" style="margin-right: 0.2rem" />
        </template>
        注册成功，请选择应税地后进行登录
      </van-notice-bar>
      <van-notice-bar class="notice-bar" color="#333" wrapable :scrollable="false" background="rgba(245, 108, 108, .1)" v-if="code == 2">
        <template #left-icon>
          <van-icon name="clear" color="#f56c6c" size="1.5em" style="margin-right: 0.2rem" />
        </template>
        注册失败，请重新注册
      </van-notice-bar>
    </div>
    <div class="city-picker">
      <van-field
        readonly
        clickable
        name="picker"
        :value="city.text"
        label="应税发生地"
        placeholder="点击选择城市"
        @click="handleShowPicker"
      />
    </div>
    <div class="tips">
      <van-notice-bar class="notice-bar" left-icon="info-o" wrapable :scrollable="false">办理开票事宜前，需要您授权登录电子税务局账号，<span v-if="city.isFace == '10020002'">认证时间为工作日06:00 - 14:00，</span>感谢配合！</van-notice-bar>
    </div>
    <div class="login-form">
      <van-field v-model="form.zh" label="账号" placeholder="请使用电子税务局账号" />
      <van-field v-model="form.mm" :type="showPassword ? 'text' : 'password'" label="密码" placeholder="请使用电子税务局密码" @click-right-icon="showPassword = !showPassword">
        <template #right-icon>
          <van-icon :name="showPassword ? 'closed-eye' : 'eye-o'" size="60rpx" color="#999" class="eye-icon" />
        </template>
      </van-field>
      <van-field v-model="form.sjyzm" center clearable label="验证码" placeholder="请输入验证码">
        <template #button>
          <van-button class="code-btn" size="large" round @click="getVerificationCode" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">
            <span v-if="isFinished">发送验证码</span>
            <template v-else>
              <van-count-down ref="countDown" :time="time" @finish="countDownFinished">
                <template #default="timeData">
                  <span class="color-white">{{ timeData.seconds }}s</span>
                </template>
              </van-count-down>
            </template>
          </van-button>
        </template>
      </van-field>
    </div>
    <div class="login-tips">
      <p>温馨提示：如未注册电子税务局账号，请点击注册按钮</p>
    </div>
    <div class="policy">
      <van-checkbox v-model="checked" shape="square">我已阅读并同意</van-checkbox><em class="primary-color" @click="toPolicyPage('https://hrcloud.ciicpt.com.cn/authority.html')">《授权协议》</em>
    </div>
    <!--登录按钮-->
    <div class="login-button">
      <van-button class="full-button" round plain :disabled="isSubmitting || isRedirecting" @click="handleRegister" color="#3062E1">注册</van-button>
      <van-button class="full-button" round :disabled="isSubmitting || isRedirecting" @click="doLogin" color="linear-gradient(90deg, #4776F0 0%, #3062E1 100%)">登录</van-button>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @change="onChange"
        @cancel="showPicker = false"
      />
    </van-popup>
    <help-video></help-video>
  </div>
  <div class="empty" v-else>
    <van-empty image="network" description="未查询到代开数据，无需进行认证" />
  </div>
</template>

<script>
  import HelpVideo from './components/HelpVideo'
  import { Toast } from 'vant';
  import { validatenull, getBrowserUserAgent } from "@/util/validate";
  import { getTaxAreaByLinkCode, checkUserStatus, sendSmsCode, taxLogin, getUrlByTaskType } from '@/api/mobile/mobile'
  export default {
    name: "authorizationForm",
    components: {
      HelpVideo
    },
    data() {
      return {
        city: {},
        columns: [],
        showPicker: false,
        form: {
          zh: '',
          mm: '',
          sjyzm: ''
        },
        isFinished: true,
        time: 60000,
        checked: false,
        recognizeUrl: '',
        code: this.$route.query.code,
        showPassword: false,
        isSubmitting: false,
        isRedirecting: false
      }
    },
    created() {
      this.getTaxArea()
    },
    methods: {
      toPolicyPage(url) {
        window.location.href = url
      },
      isRegisterSetCity() {
        if (this.isRegister) {
          const id = localStorage.getItem('baseDataId')
          const text = localStorage.getItem('baseDataName')
          this.city = {
            id,
            text,
            isFace, //该地区是否需要扫脸认证
          }
          this.handleCheckUserStatus()
        }
      },
      // 获取应税地
      getTaxArea() {
        const params = {
          linkCode: this.getLinkCode
          // linkCode: '1c9RDL01'
        }
        getTaxAreaByLinkCode(params)
        .then(res => {
          if (!validatenull(res)) {
            let columns = []
            for(let keys in res) {
              columns.push({
                text: keys.split("-")[0],
                id: res[keys],
                isFace: keys.split("-")[1],
              })
            }
            this.columns = columns
            if (columns.length == 1) {
              this.city = columns[0]
              this.setBaseDataId()
              this.handleCheckUserStatus()
            } else {
              this.isRegisterSetCity()
            }
          }
        })
      },
      // 选择城市
      handleShowPicker() {
        if (!validatenull(this.columns) && this.columns instanceof Array && this.columns.length > 1) {
          this.showPicker = true
        }
      },
      onConfirm(val) {
        if (this.city.id != val.id) {
          this.city = val
          this.setBaseDataId()
          this.handleCheckUserStatus()
        }
        this.showPicker = false
      },
      // 获取验证码
      getVerificationCode() {
        if (this.isFinished) {
          if (this.checkForm(1)) {
            const params = {
              ...this.form,
              invBaseDataId: this.getBaseDataId
            }
            sendSmsCode(params)
            .then(res => {
              this.isFinished = false
              if (this.$refs.countDown) {
                this.$refs.countDown.start();
              }
            })
          }
        }
      },
      // 倒计时结束
      countDownFinished() {
        this.isFinished = true
      },
      // 存储应税地id
      setBaseDataId() {
        const { id, text } = this.city
        localStorage.setItem('baseDataId', id)
        localStorage.setItem('baseDataName', text)
      },
      // 查询用户认证状态
      handleCheckUserStatus() {
        const params = {
          baseDataId: this.getBaseDataId
        }
        checkUserStatus(params)
        .then(res => {
          if(this.form.zh == '' && res.lastLoginName != null && res.lastLoginName != '' ){
            this.form.zh = res.lastLoginName;
          }
          this.doStatusResult(res)
        })
      },
      // 根据登录状态和认证状态判断跳转页面 true-跳转到结果页 false-跳转到人脸认证页
      doStatusResult({ recognizedStatus, loginStatus }) {
        if (this.isRedirecting) return
        if (loginStatus == 'true' || loginStatus === true) {
          this.isRedirecting = true
          if (recognizedStatus == 'true' || recognizedStatus === true || validatenull(recognizedStatus)) {
            this.$router.replace({
              name: 'AuthenticationResult',
              query: {
                code: 10
              }
            })
          } else {
            this.redirectToFaceAuth(2)
          }
        } else {
          this.isSubmitting = false
        }
      },
      redirectToFaceAuth(type) {
        this.handleGetUrlByTaskType(type).then(url => {
          Toast.loading({
            forbidClick: true,
            overlay: true,
            duration: 0,
            message: '将进行人脸识别认证...'
          })
          window.location.href = url
        }).catch(() => {
          this.isRedirecting = false
          this.isSubmitting = false
        })
      },
      // 获取税友人脸识别url 1-注册 2-扫脸认证
      handleGetUrlByTaskType(type = 2) {
        return new Promise((resolve, reject) => {
          const params = {
            urlType: type,
            invBaseDataId: this.getBaseDataId
          }
          const ua = getBrowserUserAgent()
          if (ua) {
            params.ua = ua
          }
          getUrlByTaskType(params)
          .then(url => {
            if (!validatenull(url)) {
              resolve(url)
            } else {
              reject('获取人脸识别地址失败')
            }
          })
          .catch(error => {
            reject(error)
          })
        })
      },
      // 注册
      handleRegister() {
        if (this.isSubmitting || this.isRedirecting) return
        this.isSubmitting = true
        this.isRedirecting = true
        this.redirectToFaceAuth(1)
      },
      // 表单校验 1-发送验证码 2-登录
      checkForm(type) {
        if(validatenull(this.getBaseDataId)) {
          Toast('请选择应税地')
          return false
        }
        let fields = ['zh', 'mm']
        // let fields = ['zh']
        const extraFields = ['sjyzm']
        if (type == 2) {
          fields = [...fields, ...extraFields]
        }
        const isError = fields.some(item => {
          return validatenull(this.form[item])
        })
        if (isError) {
          Toast('请完善表单信息')
        }
        return !isError
      },
      // 税局登录
      doLogin() {
        if (this.isSubmitting || this.isRedirecting) return
        if (this.checkForm(2)) {
          if (!this.checked) {
            Toast('请先阅读并同意授权协议')
            return
          }
          this.isSubmitting = true
          const params = {
            ...this.form,
            invBaseDataId: this.getBaseDataId
          }
          taxLogin(params)
          .then(res => {
            this.doStatusResult(res)
          })
          .catch(() => {
            this.isSubmitting = false
          })
        }
      }
    },
    computed: {
      getLinkCode() {
        return localStorage.getItem('linkCode')
      },
      getBaseDataId() {
        return validatenull(this.city) ? '' :  this.city.id
      },
      isNullBaseData() {
        return validatenull(this.columns)
      },
      isRegister() {
        return this.$route.path == '/mobile/authorizationRegister'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .resister-tips {
    margin-bottom: 0.1rem;
  }
  ::v-deep .van-cell {
    padding: 0.3rem 0;
    .van-field__label {
      font-weight: 500;
      color: #333;
    }
    &::after {
      left: 0;
    }
  }
  .city-picker {
    /*margin-bottom: 0.3rem;*/
  }
  .tips {
    ::v-deep .van-notice-bar {
      align-items: flex-start;
      &.van-notice-bar--wrapable {
        padding: 0.15rem 0.3rem;
      }
      .van-notice-bar__left-icon {
        line-height: 24px;
      }
    }
  }
  .login-form {
    .eye-icon {
      padding-left: 0.2rem;
      padding-right: 0.2rem;
    }
    .code-btn {
      flex-shrink: 0;
      position: absolute;
      top: 50%;
      right: 0.2rem;
      transform: translate(0, -50%);
      padding: 0 !important;
      font-size: 0.24rem !important;
      width: 1.8rem;
      height: 0.62rem !important;
      /*background: linear-gradient(90deg, #4776F0 0%, #3062E1 100%);*/
      color: #fff;
    }
  }
  .login-tips {
    color: #646566;
    font-size: 0.26rem;
    margin-top: 0.3rem;
    margin-bottom: 0.3rem;
    line-height: 20px;
    .register-btn {}
    .app-logo {
      width: 0.34rem;
      height: 0.34rem;
      margin-right: 0.06rem;
      -webkit-border-radius: 0.06rem;
      -moz-border-radius: 0.06rem;
      border-radius: 0.06rem;
      vertical-align: middle;
    }
  }
  .policy {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    font-size: 0.26rem;
    ::v-deep .van-checkbox {
      font-size: 0.26rem;
      .van-checkbox__icon--square {
        font-size: 16px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
      }
      .van-checkbox__label {
        color: #646566;
      }
    }
  }
  .empty {
    height: calc(100% - 2em);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notice-bar {
    -webkit-border-radius: 0.6rem;
    -moz-border-radius: 0.6rem;
    border-radius: 0.06rem;
  }
  .login-button {
    display: flex;
    .full-button {
      flex: 1;
      &+.full-button {
        margin-left: 0.3rem;
      }
    }
  }
</style>
